import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";

class CfdiUnidadMedida extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'cfdi-unidad/one', saveUrl: 'cfdi-unidad/save', backUrl: '/Catalogo/CfdiMedidaUnidades' },
      new Form([
        Form.Field('text', 'cfdi_clave', 'Clave', '', [Validators.required], 6),
        Form.Field('text', 'cfdi_nombre', 'Nombre', '', [Validators.required], 6),
        Form.Field('text', 'cfdi_descripcion', 'Descripcion', '', [Validators.required], 12),
      ], ['Guardar'], 'Unidad de Medida CFDI'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(CfdiUnidadMedida)
